import { render, staticRenderFns } from "./BecomePremium.vue?vue&type=template&id=b0e96122&"
import script from "./BecomePremium.vue?vue&type=script&lang=js&"
export * from "./BecomePremium.vue?vue&type=script&lang=js&"
import style0 from "./BecomePremium.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports